import React from "react";
import "./FilterDropDown.scss";

const FilterSection = ({
  title,
  options,
  selectedOptions,
  onCheckboxChange,
  filter,
  setSelectedOptions,
	onSetDataModalDescription
}) => {
  const handleUnmarkSection = (filter) => {
    const updatedOptions = selectedOptions.filter(
      (item) => item.codeItem !== filter.codes[0].codeItem
    );
    setSelectedOptions(updatedOptions);
  };

  return (
    <div className="section">
      <div className="section-header mt-3">
        <div className="heading">
          <button
            type="button"
            className="icon-info"
            onClick={() => onSetDataModalDescription({title, options})}
          >
            <h6>{title}</h6>
            <span class="material-symbols-outlined blue-text">info</span>
          </button>
        </div>
        {selectedOptions.some((i) => title.includes(i.ciDescription)) && (
          <button
            className="icon-trash blue-text pr-3"
            onClick={() => handleUnmarkSection(filter)}
          >
            <span class="material-symbols-outlined">cancel</span>
          </button>
        )}
      </div>
      <div className="checkbox-list mt-2">
        {options.map((option, index) => (
          <div
            key={`${option.value}-${index}`}
            className="checkbox-item fs-15"
            title={option.description}
            style={{
              overflow: "hidden",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            <input
              className="k-checkbox k-checkbox-md k-rounded-md check-border"
              type="checkbox"
              value={option.value}
              checked={selectedOptions.some(
                (item) =>
                  item.Value === option.value &&
                  filter.codes.some((c) => c.codeItem === item.codeItem)
              )}
              onChange={onCheckboxChange}
            />
            {option.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSection;
